import module from '../shared.module';

module.factory('AppService', [
  '$rootScope',
  function ($rootScope) {
    return {
      set pageTitle(value) {
        $rootScope.pageTitle = `UnderWraps - ${value}`;
      },
    };
  },
]);
